import { SERVICE_TABS } from "../../constant/constant";

export const allProjectManagementMiddlewareKey = {
  [SERVICE_TABS.video]: "allProjectList",
  [SERVICE_TABS.photo]: "photographyProjectList",
};

export const getAllDataProjectManagementServiceSlice = (
  state,
  serviceType = SERVICE_TABS.video
) => {
  if (!serviceType) {
    return state?.allProjectList;
  }
  return state[allProjectManagementMiddlewareKey[serviceType]];
};

export const getProjectManagementSelectorState = (
  state,
  serviceType = SERVICE_TABS.video
) => {
  if (serviceType) {
    return state.allDataProjectManagement[
      allProjectManagementMiddlewareKey[serviceType]
    ];
  }
  return state.allDataProjectManagement.allProjectList;
};

const initialJson = {
  isFetching: {
    requested: false,
    footage_received: false,
    assigned_to_editor: false,
    editing_in_progress: false,
    revision_in_progress: false,
    edit_complete: false,
    approved_by_client: false,
  },
  data: {
    requested: [],
    footage_received: [],
    assigned_to_editor: [],
    editing_in_progress: [],
    revision_in_progress: [],
    edit_complete: [],
    approved_by_client: [],
  },
  error: {
    requested: null,
    footage_received: null,
    assigned_to_editor: null,
    editing_in_progress: null,
    revision_in_progress: null,
    edit_complete: null,
    approved_by_client: null,
  },
};

export const allDataProjectManagementInitialState = {
  // Videography
  allProjectList: initialJson,

  // Photography
  photographyProjectList: initialJson,
};
